import styled from 'styled-components';
import { Column, media, hideScrollbar } from '@simplywallst/ui-core';

import { RouterLink } from '@redux-first-router-link';

export const Container = styled(Column)`
  ${media.mdDown`
      margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
      padding-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
  `}
  margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};
`;

export const Title = styled('h2')`
  ${({ theme }) => theme.typography.baseStrong};
  margin: ${({ theme }) =>
    `${theme.x1spacePx + 1}px 0`}; // 9px - Quan requested
  padding-left: ${({ theme }) => `${theme.x3spacePx}px`};
  ${media.mdDown`
    margin: ${({ theme }) => `${theme.x2spacePx}px 0`};
    padding-left: ${({ theme }) => `${theme.x2spacePx}px`};
    padding-top: 0;
    ${({ theme }) => theme.typography.largeStrong};
  `}
`;
interface WrapperProps {
  showingMarketInsight?: boolean;
}

export const Wrapper = styled('section')<WrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  ${hideScrollbar}

  ${media.lgUp`
    height: calc(100vh - 122px); // Calculate the width
    position: sticky;
    top: 64px;
    overflow-y: scroll;
  `}
`;

export const SidebarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100vh;
  ${hideScrollbar}

  ${media.mdDown`
    height: 224px;
    flex-direction: row;
    overflow-y: visible;
    overflow-x: scroll;
    margin-left: ${({ theme }) => `-${theme.x1spacePx}px`};
    padding-right: ${({ theme }) => `${theme.x2spacePx}px`};
  `}

  .braze-content-card {
    &:empty {
      display: none;
    }
    ${media.mdDown`
    background-color: ${({ theme }) => theme.color.spaceGray};
    div {
      border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
      background-color: ${({ theme }) => theme.color.spaceGray};
    }
    min-width: min(80vw, 400px);
    margin-bottom: ${({ theme }) => `${theme.x1spacePx}px`};
  `};
    ${media.smDown`
    min-width: 300px;
  `}
    border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
    margin-left: ${({ theme }) => `${theme.x3spacePx}px`};
  }
`;

export const FeedCardContainer = styled('div')`
  position: relative;
  background-color: ${({ theme }) => theme.color.noir};
  ${media.mdDown`
    min-width: 320px;
  `};
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
  margin-left: ${({ theme }) => `${theme.x3spacePx}px`};
  margin-bottom: ${({ theme }) => `${theme.x1spacePx}px`};
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
`;
